import { render, staticRenderFns } from "./MembershipLocked.vue?vue&type=template&id=6c0ff914&scoped=true&"
import script from "./MembershipLocked.vue?vue&type=script&lang=js&"
export * from "./MembershipLocked.vue?vue&type=script&lang=js&"
import style0 from "./MembershipLocked.vue?vue&type=style&index=0&id=6c0ff914&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0ff914",
  null
  
)

export default component.exports